import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { EditorComponent } from '@app/modules/shared/components/editor/editor.component'
import { environment } from '@environments/environment'
import { Persona } from '@personas/interfaces/persona.interface'
import { format, isValid } from 'date-fns'
/**
 * Displays confirmation message component & email preview
 */
@Component({
  selector: 'ngx-confirmation-preview',
  templateUrl: './confirmation-preview.component.html',
  styleUrls: ['./confirmation-preview.component.scss'],
  standalone: true,
  imports: [CommonModule, EditorComponent]
})
export class ConfirmationPreviewComponent {
  /** Regret mode, hides everything except the message editor */
  @Input()
  regret: boolean
  /** Event model */
  @Input()
  event
  /** Message form control */
  @Input()
  message: UntypedFormControl
  /** Persona that */
  @Input()
  persona: Persona

  /** True when we can show the timings card (infinite events omit public_end_date). */
  hasEventTimingPreview(): boolean {
    return !!(this.event?.public_start_date && this.event?.event_timing?.length)
  }

  /**
   * Formats a date into (Month day)
   * @param date Date
   * @returns string
   */
  getDisplayDate(date: Date | string | null | undefined): string {
    if (date == null || date === '') return ''
    const d = date instanceof Date ? date : new Date(date)
    return isValid(d) ? format(d, 'MMM d') : ''
  }

  /**
   * Formats the date into day
   * @param date Date
   * @returns string
   */
  getDay(date: Date | string | null | undefined): string {
    if (date == null || date === '') return ''
    const d = date instanceof Date ? date : new Date(date)
    return isValid(d) ? format(d, 'iii') : ''
  }

  /**
   * Generate the barcode color as per the persona options
   * @returns string
   */
  getQrCodeUrl(): string {
    return `${environment.registrationsApi}barcode/code?code=PREVIEW&type=QR&format=png&color=${encodeURIComponent(this.persona.options.barcodeColor || '#000000')}`
  }

  /**
   * Updates the property with selected value
   * @param property string
   * @param value string
   */
  update(property: string, value: string) {
    this[property].patchValue(value)
  }

  EditorOnBlur(event: string) {
    this.message.patchValue(event)
  }
}
